/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import {
  IMediaModel,
  LabelPlacement,
  MediaHelper,
  useSelector,
} from "@bms/common";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import "./MediaExpirationLabel.scss";

export interface IMediaExpirationLabelProps {
  media?: IMediaModel;
  placement?: LabelPlacement;
}

export const MediaExpirationLabel = ({
  media,
  placement = LabelPlacement.None,
}: IMediaExpirationLabelProps) => {
  const { t } = useTranslation();

  const userMediaExpirationPeriod = useSelector<string | null>((state) =>
    MediaHelper.getUserMediaExpirationPeriod(state.auth.user, media),
  );

  const labelStyle = useMemo<React.CSSProperties>(() => {
    switch (placement) {
      case LabelPlacement.TopLeft:
        return {
          top: "0.25rem",
          left: "0.25rem",
        };
      case LabelPlacement.TopRight:
        return {
          top: "0.25rem",
          right: "0.25rem",
        };
      case LabelPlacement.BottomLeft:
        return {
          bottom: "0.5rem",
          left: "0.25rem",
        };
      case LabelPlacement.BottomRight:
        return {
          bottom: "0.5rem",
          right: "0.25rem",
        };
      case LabelPlacement.Metadata:
        return {
          position: "relative",
        };
      default:
        return {
          display: "none",
        };
    }
  }, [placement]);

  if (!userMediaExpirationPeriod) {
    return null;
  }

  return (
    <div className="MediaExpirationLabel" style={labelStyle}>
      {t("MEDIA_TIME_LEFT_TO_PLAY", { timeLeft: userMediaExpirationPeriod })}
    </div>
  );
};
